var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ide',{ref:"ide",staticClass:"code-editor",attrs:{"value":_vm.code,"language":_vm.language},on:{"input":function($event){return _vm.updateCode($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }